export default __webpack_public_path__ + "static/media/SDAIA.191b3cc1.png";